import { RootState } from '../store';

export const selectLinkedCase = (state: RootState) => state.linkedCase;
